import {ITheme} from 'contexts/ThemeContext';
import {StyleSheet} from 'react-native';

export default ({colors, typography}: ITheme) =>
  StyleSheet.create({
    headerStyle: {
      backgroundColor: colors.dirtyWhite,
    },
    headerTitleStyle: {
      fontSize: 17,
      color: colors.primaryTextColor,
      ...typography.interSemiBold,
    },
  });
